import React from 'react'
import { Card, Tooltip } from 'antd'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

import l1 from '../../../../assets/ui-layout/1.png'
import l2 from '../../../../assets/ui-layout/2.png'
import l3 from '../../../../assets/ui-layout/3.png'
import l4 from '../../../../assets/ui-layout/4.png'
import l5 from '../../../../assets/ui-layout/5.png'
import l6 from '../../../../assets/ui-layout/6.png'
import l7 from '../../../../assets/ui-layout/7.png'
import l8 from '../../../../assets/ui-layout/8.png'
import l9 from '../../../../assets/ui-layout/9.png'
import l10 from '../../../../assets/ui-layout/10.png'

const images = {
  1: l3,
  2: l2,
  3: l1,
  4: l4,
  5: l5,
  6: l6,
  7: l7,
  8: l8,
  9: l9,
  10: l10,
}

const PreviewItem = ({ item, onSelect }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: item.id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <div ref={setNodeRef} style={style} {...attributes}>
      <Tooltip title={`Layout ${item.layoutId}`} placement="left">
        <Card
          size="small"
          hoverable
          bodyStyle={{ padding: 6 }}
          style={{ marginBottom: 10 }}
          onClick={() => onSelect(item.id)}
        >
          <img
            {...listeners}
            src={images[item.layoutId]}
            alt=""
            style={{
              width: '100%',
              borderRadius: 4,
              cursor: 'grab',
            }}
          />
        </Card>
      </Tooltip>
    </div>
  )
}

const PreviewMenu = ({ items, onSelect }) => {
  return (
    <div style={{ padding: 8 }}>
      {items.map(item => (
        <PreviewItem
          key={item.id}
          item={item}
          onSelect={onSelect}
        />
      ))}
    </div>
  )
}

export default PreviewMenu
